import { useMemo } from "react";
import { bool, object } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { getPercentWorkTypes } from "@utils";
import {
  useEstimateEditorStore,
  useEstimateEditorSettings,
  useEstimateStructure,
  ElementChatPopup,
  TimelineSettings,
  VisibilityButton,
} from "@tools";
import { TooltipIcon } from "@components";
import { Percent } from "@assets";

export const TimelineRowActions = observer(({
  workType,
  opened,
}) => {
  const { t } = useTranslation();
  const { visibilityMode } = useEstimateEditorStore();
  const structure = useEstimateStructure();
  const { allowEdition, showChatThread } = useEstimateEditorSettings();
  
  const { id, name, treePath, hasPercent, usesTimelinePercent, hideOnTimeline, percentageWorkTypes } = workType;
  
  const commentPath = "t" + treePath.join("/");

  const percentWorkTypes = useMemo(() => (
    getPercentWorkTypes(percentageWorkTypes)
  ), [structure.percentageWorkTypes, percentageWorkTypes]);

  return (
    <>
      {
        allowEdition && hasPercent && usesTimelinePercent &&
        <TooltipIcon
          icon={<Percent />}
          color="primary"
          className="noDrag"
        >
          {percentWorkTypes}
        </TooltipIcon>
      }
      {
        allowEdition &&
        <TimelineSettings
          fullSettings
          className="button-wta-settings hoverIcon opq"
          selectedWorkType={id}
        />
      }
      {
        visibilityMode &&
        <VisibilityButton
          hidden={hideOnTimeline}
          onChange={workType.setHideOnTimeline}
          inRow
        />
      }
      {
        showChatThread &&
        <ElementChatPopup
          rowThread
          path={commentPath}
          taskName={name || t("common.unnamed")}
          hideBadge={opened}
        />
      }
    </>
  );
});

TimelineRowActions.propTypes = {
  workType: object.isRequired,
  opened: bool,
};
